import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/material/migration/migration-v4/v5-style-changes.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
